import React, { useEffect, useState } from 'react';
import { fetchPowerStatus } from './api';

// Surfaces go-api's /power-status flag (see power_monitor.go) as a fixed
// top banner, visible on the gate/splash/login screens as well as once
// logged in -- mounted unconditionally at the top of App.jsx for that
// reason. Polls independently of auth state; a failed/unreachable fetch
// is treated as "unknown," never as "outage" -- go-api being unreachable
// is the ordinary idle-sleep case (handled separately by ServerWakingScreen),
// not evidence of a wall-power outage.
const POLL_MS = 20000;

const PowerOutageBanner = () => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      const data = await fetchPowerStatus();
      if (!cancelled && data) setStatus(data);
    };
    poll();
    const id = setInterval(poll, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (!status || !status.outage) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10000,
        padding: '10px 16px',
        background: 'rgba(40,6,6,0.95)',
        borderBottom: '1px solid rgba(255,60,60,0.5)',
        boxShadow: '0 0 20px rgba(255,60,60,0.25)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        fontFamily: 'Rajdhani, sans-serif',
        textAlign: 'center',
      }}
    >
      <span
        style={{
          fontFamily: 'Orbitron, monospace',
          fontSize: '10px',
          fontWeight: 900,
          letterSpacing: '0.15em',
          color: '#ff3c3c',
          flexShrink: 0,
        }}
      >
        ⚠ POWER OUTAGE
      </span>
      <span style={{ fontSize: '13px', color: '#e8b8b8' }}>
        {status.message || 'Wall power outage detected. This server may go offline.'}
      </span>
    </div>
  );
};

export default PowerOutageBanner;
